<template>
  <div class="bigBg" id="bigPage" style="display: flex; flex-wrap: wrap">
    <div class="pageTop1">
      <div style="width: 33.33%">
        <img
          src="../../assets/imgs/logo.png"
          alt=""
          style="
            width: 80px;
            height: 20px;
            margin-left: 16px;
            margin-top: -30px;
          "
        />
      </div>
      <div
        style="
          color: #2bc7ff;
          font-size: 24px;
          width: 33.33%;
          text-align: center;
          font-weight: bold;
        "
      >
        咖德保安大数据运行专题
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          width: 33.33%;
          justify-content: center;
          color: #fff;
        "
      >
        <div>按地区</div>
        <el-select
          v-model="value1"
          placeholder="请选择"
          @change="handleChange"
          class="custom-select"
          style="
            margin-left: 8px;
            width: 100px;
            min-height: 20 !important;
            height: 20px !important;
          "
        >
          <el-option label="全国" value="全国"></el-option>
          <el-option label="广东" value="广东"></el-option>
          <el-option label="北京" value="北京"></el-option>
          <el-option label="上海" value="上海"></el-option>
        </el-select>
        <img src="../../assets/imgs/refresh.png" alt="" class="smallIcon" />
        <img src="../../assets/imgs/clear.png" alt="" class="smallIcon" />
        <img src="../../assets/imgs/big.png" alt="" class="smallIcon" />
        <div style="margin-left: 20px; margin-top: -6px">
          2025年10月14日 &nbsp;&nbsp;&nbsp;12:12
        </div>
      </div>
    </div>
    <!-- <mapp style="width: 600px; height: 400px" /> -->
    <!-- <mapp1 style="width: 600px; height: 400px" /> -->
    <div ref="echartsRef" style="width: 600px; height: 400px"></div>
    <div ref="chartContainer" style="width: 600px; height: 400px"></div>
    <div
      ref="echartsRef1"
      style="width: 600px; height: 400px"
      @mouseenter="kk"
      @mouseleave="startInterval"
    ></div>
    <div ref="chartContainer1" style="width: 600px; height: 400px"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import chinaJson from "../../china.json"; // 引入地图数据
// import mapp from "../../components/map.vue";
// import mapp1 from "../../components/map1.vue";
export default {
  // components: { mapp, mapp1 },
  name: "ChinaMap",
  data() {
    return {
      //地图数据
      dataList: [
        {
          name: "南海诸岛",
          value: 25,
        },
        {
          name: "北京",
          value: 71,
        },
        {
          name: "天津",
          value: 52,
        },
        {
          name: "上海",
          value: 14,
        },
        {
          name: "重庆",
          value: 50,
        },
        {
          name: "河北",
          value: 20,
        },
        {
          name: "河南",
          value: 30,
        },
        {
          name: "云南",
          value: 55,
        },
        {
          name: "辽宁",
          value: 50,
        },
        {
          name: "黑龙江",
          value: 40,
        },
        {
          name: "湖南",
          value: 6,
        },
        {
          name: "安徽",
          value: 96,
        },
        {
          name: "山东",
          value: 75,
        },
        {
          name: "新疆",
          value: 45,
        },
        {
          name: "江苏",
          value: 15,
        },
        {
          name: "浙江",
          value: 8,
        },
        {
          name: "江西",
          value: 78,
        },
        {
          name: "湖北",
          value: 78,
        },
        {
          name: "广西",
          value: 36,
        },
        {
          name: "甘肃",
          value: 25,
        },
        {
          name: "山西",
          value: 140,
        },
        {
          name: "内蒙古",
          value: 85,
        },
        {
          name: "陕西",
          value: 85,
        },
        {
          name: "吉林",
          value: 74,
        },
        {
          name: "福建",
          value: 20,
        },
        {
          name: "贵州",
          value: 74,
        },
        {
          name: "广东",
          value: 47,
        },
        {
          name: "青海",
          value: 45,
        },
        {
          name: "西藏",
          value: 41,
        },
        {
          name: "四川",
          value: 3,
        },
        {
          name: "宁夏",
          value: 7,
        },
        {
          name: "海南",
          value: 7,
        },
        {
          name: "台湾",
          value: 200,
        },
        {
          name: "香港",
          value: 2,
        },
        {
          name: "澳门",
          value: 5,
        },
      ],
      option: {
        //标题组件
        title: {
          show: true,
          text: "全国各省份旅游景点(已评级)数量",
          subtext: "截至到2021年12月",
          left: "center",
          top: 16,
        },
        //提示框组件
        tooltip: {
          show: true,
          //触发类型：数据项图形触发
          trigger: "item",
          padding: 10,
          borderWidth: 1,
          borderColor: "#409eff",
          backgroundColor: "rgba(255,255,255,0.4)",
          textStyle: {
            color: "#000000",
            fontSize: 12,
          },
          //提示框内容格式器
          formatter: (e) => {
            let data = e.data;
            //此处将各等级景点数量表示为0-10内的随机整数
            data.five = (Math.random() * 10) | 0;
            data.four = (Math.random() * 10) | 0;
            data.three = (Math.random() * 10) | 0;
            data.two = (Math.random() * 10) | 0;
            data.one = (Math.random() * 10) | 0;
            //景点数量 - 五个等级之和
            data.number =
              data.five + data.four + data.three + data.two + data.one;
            //字符串模板
            let context = `
               <div>
                   <p style="line-height: 30px; font-weight: 600">${data.name}</p>
                   <p><span>景点数量 : </span><span>${data.number}处</span></p>
                   <p><span>5A级 : </span><span>${data.five}处</span></p>
                   <p><span>4A级 : </span><span>${data.four}处</span></p>
                   <p><span>3A级 : </span><span>${data.three}处</span></p>
                   <p><span>2A级 : </span><span>${data.two}处</span></p>
                   <p><span>1A级 : </span><span>${data.one}处</span></p>
               </div>
            `;
            return context;
          },
        },
        //视觉映射组件(左下角)
        visualMap: {
          show: true,
          left: 26,
          bottom: 40,
          showLabel: true,
          // 是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
          calculable: false,
          // 拖拽时，是否实时更新
          realtime: true,
          align: "left",
          //各颜色代表的区域
          pieces: [
            {
              gte: 100,
              label: "> 100",
              color: "#FDB669",
            },
            {
              gte: 50,
              lt: 99,
              label: "50 - 99",
              color: "#FECA7B",
            },
            {
              gte: 30,
              lt: 49,
              label: "30 - 49",
              color: "#FEE191",
            },
            {
              gte: 10,
              lt: 29,
              label: "10 - 29",
              color: "#FFF0A8",
            },
            {
              lt: 9,
              label: "< 10",
              color: "#FFFFBF",
            },
          ],
        },
        //地理坐标系组件
        geo: {
          //使用 registerMap 注册的地图名称
          map: "china",
          //是否开启鼠标缩放和平移漫游
          roam: true,
          //当前视角缩放比例
          zoom: 1,
          //滚轮缩放的极限控制
          scaleLimit: {
            min: 1, //最小1倍
            max: 3, //最大3倍
          },
          //地图组件离容器的距离
          top: 90,
          left: "center",
          //图形上的文本标签
          label: {
            show: true,
            fontSize: "11",
          },
          //地图区域的多边形 图形样式
          itemStyle: {
            borderColor: "rgba(0, 0, 0, 0.2)",
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowBlur: 10,
            // 高亮状态(鼠标移入后)的多边形和标签样式
            emphasis: {
              areaColor: "#f98333",
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
          },
        },
        series: [
          {
            type: "map",
            roam: true,
            geoIndex: 0,
            data: "",
            label: {
              show: true,
            },
          },
        ],
      },
      // 柱状图数据
      chartData: {
        xAxisData: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        seriesData: [
          { name: "部门A", data: [120, 200, 150, 80, 70, 110, 130] },
          { name: "部门B", data: [150, 80, 140, 200, 150, 80, 110] },
          { name: "部门C", data: [160, 170, 180, 190, 200, 180, 170] },
          { name: "部门D", data: [80, 70, 60, 150, 140, 130, 120] },
        ],
      },
      //折线图数据
      chartData1: {
        days: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        counts: [120, 200, 150, 80, 70, 110, 130], // 示例数据
      },
      chartInstance: null,
      currentIndex: 0, //当前选中的项索引，默认为0（第一个）
      intervalId: null,
      options: [
        { value: 335, name: "直接访问" },
        { value: 310, name: "邮件营销" },
        { value: 274, name: "联盟广告" },
        { value: 235, name: "视频广告" },
        { value: 400, name: "搜索引擎" },
      ],
      value1: "全国", //城市下拉框默认值
    };
  },
  created() {
    this.setEchartOption();
  },
  mounted() {
    echarts.registerMap("china", chinaJson);
    this.$nextTick(() => {
      this.draw_map();
    });
    this.initChart();
    this.initChart1();
    this.initChart2();
    this.startInterval();
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    //地图
    draw_map() {
      let myChart = echarts.init(this.$refs.echartsRef);
      //高亮轮播展示
      var hourIndex = 0;
      var carouselTime = null;
      carouselTime = setInterval(() => {
        //dispatchAction echarts的API：触发图表行为
        myChart.dispatchAction({
          type: "downplay", //downplay 取消高亮指定的数据图形
          seriesIndex: 0,
        });
        myChart.dispatchAction({
          type: "highlight", //highLight 高亮指定的数据图形
          seriesIndex: 0, //系列index
          dataIndex: hourIndex, //数据index
        });
        myChart.dispatchAction({
          type: "showTip", //showTip 显示提示框
          seriesIndex: 0,
          dataIndex: hourIndex,
        });
        hourIndex++;
        //当循环到数组当中的最后一条数据后，重新进行循环
        if (hourIndex > this.dataList.length) {
          hourIndex = 0;
        }
      }, 3000);
      //鼠标移入组件时停止轮播
      myChart.on("mousemove", (e) => {
        clearInterval(carouselTime); //清除循环
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
      });
      //鼠标移出组件时恢复轮播
      myChart.on("mouseout", () => {
        carouselTime = setInterval(() => {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
          });
          myChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: hourIndex,
          });
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: hourIndex,
          });
          hourIndex++;
          if (hourIndex > this.dataList.length) {
            hourIndex = 0;
          }
        }, 3000);
      });
      myChart.on("click", (e) => {
        console.log(e);
      });
      //显示地图
      myChart.setOption(this.option);
    },
    //修改echart配制
    setEchartOption() {
      this.option.series[0].data = this.dataList;
    },
    //地图
    //柱状图
    initChart() {
      var myChart = echarts.init(this.$refs.chartContainer);
      var option = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: this.chartData.seriesData.map((item) => item.name),
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.chartData.xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: this.chartData.seriesData.map((item) => ({
          name: item.name,
          type: "bar",
          data: item.data,
          // stack: "total" // 可选，用于堆叠柱状图效果
        })),
      };
      myChart.setOption(option);
    },
    //柱状图
    //饼状图
    initChart1() {
      const chartDom = this.$refs.echartsRef1;
      if (chartDom) {
        this.chartInstance = echarts.init(chartDom);
        const option = {
          title: {
            text: "",
            subtext: "",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
            data: this.options.map((item) => item.name),
          },
          series: [
            {
              name: "数量",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: this.options,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        this.chartInstance.setOption(option);

        // 初始高亮第一个数据项
        this.highlightCurrentIndex();
      }
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        // 取消当前高亮
        this.chartInstance.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: this.currentIndex,
        });

        // 更新索引
        this.currentIndex = (this.currentIndex + 1) % this.options.length;

        // 高亮下一个
        this.highlightCurrentIndex();

        // 显示提示框
        this.chartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.currentIndex,
        });
      }, 2000); // 每2秒切换一次
    },
    kk() {
      this.stopInterval();
    },
    stopInterval() {
      this.chartInstance.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: this.currentIndex,
      });
      clearInterval(this.intervalId);
    },
    highlightCurrentIndex() {
      this.chartInstance.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: this.currentIndex,
      });
    },
    //饼状图
    //折线图
    initChart2() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(this.$refs.chartContainer1);
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: "一周每天数量",
        },
        tooltip: {},
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: this.chartData1.days, // X轴数据（一周的每一天）
        },
        yAxis: {},
        series: [
          {
            name: "数量",
            type: "line", // 指定图表类型为折线图
            data: this.chartData1.counts, // Y轴数据（每天的数量）
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    //折线图
  },
  beforeDestroy() {
    this.stopInterval();
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
};
</script>
<style scoped>
.bigBg {
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/imgs/350.png");
  background-size: 100% 100%;
}
.pageTop1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  background-image: url("../../assets/imgs/pageTop.png");
  background-size: 100% 100%;
}
.smallIcon {
  width: 12px;
  height: 12px;
  margin: 0 8px;
  cursor: pointer;
  margin-top: -4px;
}
</style>
